import React, { useEffect, useState, useRef } from 'react';
import {
  Modal,
  Form,
  Select,
  notification,
  Button,
  Spin,
  Tabs,
  Input,
  Tooltip,
} from 'antd';
import { PlusIcon, SearchIcon, TrashIcon } from '@heroicons/react/outline';
import debounce from '../../helpers/debounce';
import axios from 'axios';
import Errors from '../errors';
import { useDispatch } from 'react-redux';
import { addHieloco } from '../../store/actions/hielocos';

const { Option } = Select;

const CreateHieloco = () => {
  const [modal, showModal] = useState(false);
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const [poaps, setPoaps] = useState([]);
  const [poap, setPoap] = useState(null);
  const [hieloco, setHieloco] = useState({ name: '', picture: null });
  const [loading, setLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);

  const { picture } = hieloco;

  const formRef = useRef();
  const formHielocoRef = useRef();
  const inputFileRef = useRef();

  useEffect(() => {
    searchPOAPS();
    //eslint-disable-next-line
  }, [search]);

  function searchPOAPS() {
    if (!search) return setPoaps([]);
    const beginSearch = async () => {
      try {
        setLoadingSearch(true);
        const response = await axios.get(
          `https://api.poap.xyz/paginated-events?limit=10&name=${search}&offset=0&private_event=false&sort_dir=desc&sort_field=id`
        );

        const poaps = response.data.items;

        setPoaps(poaps);
        setTimeout(() => {
          setLoadingSearch(false);
        }, 500);
      } catch (error) {
        setLoadingSearch(false);
        notification.open({
          type: 'error',
          message: 'Error al cargar los POAPS. Contacte a soporte.',
          description: `Error, ${error.message || 'POAP API Cannot GET'}`,
          placement: 'bottomRight',
        });
      }
    };

    debounce(beginSearch);
  }

  async function handlecreateHieloco() {
    try {
      setLoading(true);

      const response = await dispatch(addHieloco(JSON.parse(poap)));

      showModal(false);
      notification.open({
        type: 'success',
        message: response.message,
        placement: 'bottomRight',
      });

      //Reset
      setPoaps([]);
      setPoap(null);
      formRef.current.resetFields();
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      notification.open({
        type: 'error',
        message: 'Ocurrio un error al guardar el poap',
        description: <Errors errors={error?.errors} />,
        placement: 'bottomRight',
      });
    }
  }

  async function handlecreateLocalHieloco() {
    try {
      setLoading(true);

      await formHielocoRef.current.validateFields();

      if (!picture) {
        return notification.open({
          placement: 'bottomRight',
          type: 'error',
          message: 'Seleccione la imagen del poap',
        });
      }

      try {
        const response = await dispatch(addHieloco(hieloco, true));

        showModal(false);
        notification.open({
          type: 'success',
          message: response.message,
          placement: 'bottomRight',
        });

        formHielocoRef.current.resetFields();
        setLoading(false);
      } catch (error) {
        setLoading(false);
        notification.open({
          type: 'error',
          message: 'Ocurrio un error al guardar el poap',
          description: <Errors errors={error?.errors} />,
          placement: 'bottomRight',
        });
      }
    } catch (error) {
      setLoading(false);

      console.log(error);
    }
  }

  const setHielocoPicture = (e) => {
    try {
      const picture = e.target.files[0];

      if (picture) {
        setHieloco({ ...hieloco, picture });
      }
    } catch (error) {}
  };

  const deleteHielocoPicture = () => {
    setHieloco({ ...hieloco, picture: null });

    inputFileRef.current.value = '';
  };

  const poapsOptions = poaps.map((poap) => (
    <Option key={poap.id} value={JSON.stringify(poap)}>
      <div className="flex gap-2 items-center">
        <img alt="POAPImage" src={poap.image_url} className="h-8" />
        <span className="w-full truncate">{poap.name}</span>
      </div>
    </Option>
  ));

  return (
    <>
      <Button
        onClick={() => showModal(true)}
        className="flex items-center justify-center gap-1 text-white bg-cyan-500 hover:bg-cyan-600 hover:text-white focus:bg-cyan-700 focus:text-white font-medium transition mb-4 lg:mb-0"
        style={{ width: 150, height: 40 }}
      >
        Nuevo poap <PlusIcon width={20} />
      </Button>
      <Modal
        visible={modal}
        title={<h1 className="text-lg">Nuevo poap</h1>}
        footer={null}
        onCancel={() => showModal(false)}
        bodyStyle={{ paddingTop: 0 }}
      >
        <Tabs>
          <Tabs.TabPane tab="POAP" key="POAP" disabled={loading}>
            <img
              alt="POAPLogo"
              src="https://app.poap.xyz/static/media/POAP.837f6c9b.svg"
              className="h-12"
            />
            <div className="py-2">
              <div className="font-medium">Instrucciones:</div>
              <ol>
                <li>1. Busque el nombre del POAP.</li>
                <li>2. Seleccione el POAP de la lista.</li>
                <li>3. Confirme la selección.</li>
              </ol>
            </div>

            <Form ref={formRef}>
              <Form.Item name="search">
                <Select
                  placeholder="Buscar POAP"
                  showSearch
                  value={poap}
                  showArrow={false}
                  onChange={(value) => setPoap(value)}
                  onSearch={(search) => setSearch(search)}
                  filterOption={false}
                  notFoundContent={
                    search &&
                    !loadingSearch && <div>No se encontrarón POAPS.</div>
                  }
                  size="large"
                  className="rounded-sm"
                >
                  {poapsOptions}
                </Select>
                <div className="absolute right-2 top-3 flex gap-2">
                  {loadingSearch && <Spin size="small" />}
                  <SearchIcon
                    width={18}
                    className="text-black text-opacity-50"
                  />
                </div>
              </Form.Item>
            </Form>
            <div className="flex justify-end gap-4">
              <Button onClick={() => showModal(false)}>Cancelar</Button>
              <Button
                type="primary"
                disabled={!poap || loading}
                onClick={handlecreateHieloco}
              >
                Guardar {loading && <Spin size="small" className="ml-2" />}
              </Button>
            </div>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Local" key="Local" disabled={loading}>
            <div className="mb-2">Por favor ingrese los campos solicitados</div>
            <Form ref={formHielocoRef}>
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: 'Debe ingresar el nombre del poap',
                  },
                ]}
              >
                <Input
                  placeholder="Nombre"
                  onChange={(e) =>
                    setHieloco({ ...hieloco, name: e.target.value })
                  }
                />
              </Form.Item>
            </Form>

            {!hieloco.picture ? (
              <div
                onClick={() => inputFileRef.current.click()}
                className="w-24 h-28 border-black border-2 border-dashed flex items-center justify-center text-center cursor-pointer hover:shadow-md hover:bg-gray-100 transition shadow"
              >
                Seleccionar imagen
              </div>
            ) : (
              <div className="relative w-24 h-28 bg-white rounded-md">
                <img
                  alt={'hieloco_picture'}
                  src={URL.createObjectURL(hieloco.picture)}
                  className="object-cover h-full rounded-md"
                />
                <Tooltip title="Eliminar" placement="right">
                  <div
                    onClick={() => deleteHielocoPicture()}
                    className="absolute -top-2 -right-2 bg-white shadow-lg rounded-full cursor-pointer w-7 h-7 flex items-center justify-center hover:shadow-xl hover:scale-105 transform transition"
                  >
                    <TrashIcon width={22} color="red" />
                  </div>
                </Tooltip>
              </div>
            )}

            <input
              ref={inputFileRef}
              type="file"
              style={{ display: 'none' }}
              accept="image/png, image/jpeg"
              onChange={(e) => setHielocoPicture(e)}
            />

            <div className="flex justify-end gap-4">
              <Button onClick={() => showModal(false)}>Cancelar</Button>
              <Button
                type="primary"
                disabled={loading}
                onClick={handlecreateLocalHieloco}
              >
                Guardar {loading && <Spin size="small" className="ml-2" />}
              </Button>
            </div>
          </Tabs.TabPane>
        </Tabs>
      </Modal>
    </>
  );
};

export default CreateHieloco;
